import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Spinner } from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import { useEffect } from 'react';
import { shallowEqual } from 'react-redux';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
import { useAppSelector } from 'utils/redux/useAppSelector';
import { activityLogActions } from '../actions/activityLog';
import styles from './activityLog.module.scss';
import { ComponentByLogType } from './activityTypes';
/**
 * Represents a component that outputs the log entries for the main
 * conversation.
 */
export function ActivityLog() {
    const dispatch = useAppDispatch();
    const { metaConversation: { conversation, messages }, activityLog: { entries, asyncStatus }, } = useAppSelector((state) => ({
        metaConversation: state.conversation.metaConversation,
        activityLog: state.activityLog,
    }), shallowEqual);
    useEffect(() => {
        if (conversation.id) {
            dispatch(activityLogActions.get({ csid: conversation.id }));
        }
    }, [conversation.id]);
    useEffect(() => {
        return () => {
            dispatch(activityLogActions.toggle({ open: false }));
        };
    }, []);
    return (_jsxs("div", Object.assign({ className: classnames({
            [styles.root]: true,
            [styles.hasLogs]: entries.length,
        }) }, { children: [asyncStatus === 'loading' && (_jsx("div", Object.assign({ className: styles.spinnerContainer, "data-testid": "spinner" }, { children: _jsx(Spinner, {}) }))), asyncStatus === 'failed' && (_jsx("span", Object.assign({ className: styles.error }, { children: "Failed to retrieve Activity Log." }))), asyncStatus === 'succeeded' &&
                (entries.length
                    ? entries.map((entry) => (_jsx(ComponentByLogType, { entry: entry, messages: messages }, entry.event_id)))
                    : 'No events to display.')] })));
}
